import React, { useEffect, useRef, useState } from "react";
import RecentRequestSection from "./RecentRequestSection";
import RequestDetailsHeader from "./RequestDetailsHeader";
import RequestDetailsSection from "./RequestDetailsSection";
import { AEROMEGH_SERVICES, STATUS, STATUS_MESSAGES } from "../../appConstants";
import dateFormat from "dateformat";
import VerticalStepper from "../../ReusableComponents/VerticalStepper";
import { getRequest, getRequests } from "../../apis/requests";
import Popup from "../../ReusableFunctions/Popup";
import Loading from "../../ReusableFunctions/Loader";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";

export default function RequestsOverView() {
  const [requests, setRequests] = useState([]);
  const{user}=useSelector((state)=>state.user);
  const [isLoading, setIsLoading] = useState(false);
  const [recentRequestsLoading, setrecentRequestsLoading] = useState(false);
  const [previousRequestLoading, setPreviousRequestLoading] = useState(false);
  const { state } = useLocation();
  const navigate = useNavigate();
  const [steps, setSteps] = useState([]);
  const [comments, setComments] = useState([])
  const [selectedRequest, setselectedRequest] = useState(undefined);
  const [sprayingRequest, setSprayingRequest] = useState({}); // Move state here
  const [popupState, setPopupState] = useState({
    reschedule: false,
    cancel: false,
    hold:false,
    complete: false,
  });
  const [filters, setFilters] = useState(state?.filters || {});
  const [hasMore, setHasMore] = useState(true);
  const [initialLoad, setInitialLoad] = useState(true);
  const requestInvoiceRef = useRef();
  const [selectedStatus, setSelectedStatus] = useState(selectedRequest?.status)
    
  const getRequestsAPI = async (
    pageSize,
    pageNumber,
    statusType,
    filters,
    searchQuery,
    fromDate,
    toDate,
    pilotId,
    isOrderByServiceTime,
    userId,
  ) => {
    try {
      setIsLoading(true);
      const data = await getRequests(
        userId,
        filters,
        pageSize,
        pageNumber,
        statusType,
        searchQuery,
        fromDate,
        toDate,
        pilotId,
        isOrderByServiceTime?isOrderByServiceTime:false,
      );
      setRequests(data.requests);
      setselectedRequest(state?.request);
      setSelectedStatus(state?.request?.status);
      setIsLoading(false);
    } catch (err) {
      console.log("errr:", err);
      setIsLoading(false);
      Loading.set(false);
      Popup.alert("Error", err, "ERROR");
    }
  };

  const getInitalData = async () => {
    try {
      await getRequestsAPI(
        15,
        filters?.pageNumber,
        filters?.statusType,
        {
          locations: filters?.locations,
          services: filters?.services,
          statuses: filters?.statuses,
          orderBy:filters?.orderBy,
          orderType:filters?.orderType,
        },
        null,
        filters?.fromDate ? new Date(new Date(filters?.fromDate).setHours(0,0,0,0)).toISOString():undefined,
        filters?.toDate ? new Date(new Date(filters?.toDate).setHours(23,59,59,999)).toISOString():undefined,
        filters?.pilotId?filters.pilotId:undefined,
        filters?.isOrderByServiceTime? filters?.isOrderByServiceTime:undefined,
        filters.userId,
      );
    } catch (error) {
      console.log("error", error);
    }
  };


  const fetchPreviousRequests=async(pageNumber)=>{
   if(pageNumber<1 ) return ;
   try {
    setPreviousRequestLoading(true);
    const data = await getRequests(
      filters.userId,
      {
        locations: filters?.locations,
        services: filters?.services,
        statuses: filters?.statuses,
        orderBy:filters?.orderBy,
        orderType:filters?.orderType,
      },
      15, 
      pageNumber,
      filters?.statusType,
      null,
      filters?.fromDate ? new Date(new Date(filters?.fromDate).setHours(0, 0, 0, 0)).toISOString() : undefined,
      filters?.toDate ? new Date(new Date(filters?.toDate).setHours(23, 59, 59, 999)).toISOString() : undefined,
      undefined,
      false,
    );

    if (data.requests.length > 0) {
      setRequests((prevRequests) => [ ...data.requests,...prevRequests]);
    }
  } catch (err) {
    Popup.alert("Error", err, "ERROR");
  }finally{
    setTimeout(() => setPreviousRequestLoading(false), 500);
  }
  }


  const fetchMoreRequests = async (pageNumber) => {
    if (!hasMore ) return;
    setrecentRequestsLoading(true);
    try {
      const data = await getRequests(
        filters.userId,
        {
          locations: filters?.locations,
          services: filters?.services,
          statuses: filters?.statuses,
          orderBy:filters?.orderBy,
          orderType:filters?.orderType,
        },
        15, 
        pageNumber,
        filters?.statusType,
        null,
        filters?.fromDate ? new Date(new Date(filters?.fromDate).setHours(0, 0, 0, 0)).toISOString() : undefined,
        filters?.toDate ? new Date(new Date(filters?.toDate).setHours(23, 59, 59, 999)).toISOString() : undefined,
        undefined,
        false,
      );

      if (data.requests.length > 0) {
        setRequests((prevRequests) => [...prevRequests, ...data.requests]);
        setFilters((prevFilters)=>({
          ...prevFilters,
          pageNumber:pageNumber
        }))
      } else {
        setHasMore(false);
      }
    } catch (err) {
      Popup.alert("Error", err, "ERROR");
    }finally{
      setrecentRequestsLoading(false);
    }
  };

  const getRequestDetails = async () => {
    if (!selectedRequest?.id) return;
    setIsLoading(true);
    let requestData = await getRequest(
      {
        type: selectedRequest?.type || AEROMEGH_SERVICES.SPRAYING,
        id: selectedRequest?.id,
      },
      true,
      true,
      true,
      true
    );
    setselectedRequest(()=>({ ...selectedRequest, ...requestData.request }));
    setselectedRequest((prev) => ({
      ...prev,
      type: prev.invoice.request_type,
    }));
    setSelectedStatus(requestData.request.status)
      setSteps(requestData.request.status_history?.filter((req)=>req.updated_status!=="Transferred")?.map((record) => {
        return {
          label: record.updated_status,
          content: (
            <>
              <div
                style={{
                  color: "rgb(59, 59, 59)",
                  fontSize: "13px",
                  fontWeight: "500",
                  wordBreak: "break-word",
                  marginBottom: "0px",
                }}
              >
                {record.updated_status == STATUS.PLACED
                  ? STATUS_MESSAGES.PLACED
                  : record.updated_status == STATUS.ACCEPTED
                  ? STATUS_MESSAGES.ACCEPTED
                  : record.updated_status == STATUS.RESCHEDULED
                  ? STATUS_MESSAGES.RESCHEDULED
                  : record.updated_status == STATUS.OUT_FOR_SERVICE
                  ? STATUS_MESSAGES.OUT_FOR_SERVICE
                  : record.updated_status == STATUS.INPROGRESS
                  ? STATUS_MESSAGES.INPROGRESS
                  : record.updated_status == STATUS.COMPLETED
                  ? STATUS_MESSAGES.COMPLETED
                  : record.updated_status == STATUS.PAID
                  ? STATUS_MESSAGES.PAID
                  : record.updated_status == STATUS.CANCELLED
                  ? STATUS_MESSAGES.CANCELLED
                  : record.updated_status == STATUS.HOLD
                  ? STATUS_MESSAGES.HOLD
                  : ""}
              </div>
              {record?.note && (
                <div
                  style={{
                    lineHeight: "16px",
                    margin: "5px 0px",
                    fontSize: "13px",
                  }}
                >
                  <span style={{ marginRight: "3px", fontWeight: 500 }}>
                    Note :
                  </span>
                  <span style={{ color: "#3b3b3b", fontWeight: 500,wordWrap:"break-word" }}>
                    {record.note}
                  </span>
                  <br />
                  {record.updated_status === STATUS.CANCELLED &&
                    requestData?.request?.cancelledRequestDetails && (
                      <div className="mt-1">
                        Cancelled by  
                        {
                          " " + requestData?.request?.cancelledRequestDetails
                            ?.user_role
                        }
                      </div>
                    )}
                  {/* {record.updated_status === STATUS.CANCELLED &&
                    requestData?.request?.cancelledRequestDetails && (
                      <div className="mt-1">
                        User Role:
                        {
                          requestData?.request?.cancelledRequestDetails
                            ?.user_role
                        }
                      </div>
                    )} */}
                </div>
              )}
              <div
                style={{
                  color: "#727272",
                  fontSize: "13px",
                  fontWeight: "600",
                }}
              >{`${dateFormat(
                new Date(record.time),
                "h : MM TT"
              )}, ${dateFormat(new Date(record.time), "d mmmm yyyy")}`}</div>
            </>
          ),
          statusColor:
            record.updated_status == STATUS.RESCHEDULED
              ? "#E27444"
              : record.updated_status == STATUS.CANCELLED
              ? "#EB0000"
              : "#32B338",
          highlightStatus:
            record.updated_status == STATUS.RESCHEDULED ||
            record.updated_status == STATUS.CANCELLED,
        };
      })
    );
   setComments(()=>requestData?.request?.comments)
    setIsLoading(false);
  };

  useEffect(() => {
    if (state?.request) {
      if (initialLoad) {
        getInitalData();
        setInitialLoad(false);
      }
    } else {
      navigate("/manageRequests");
    }
  }, [state?.request]);

  useEffect(() => {
    getRequestDetails();
  }, [selectedRequest?.id]);


  return (
    <div className="w-full px-10 py-8 bg-[#D9D9D9] h-[100%] font-manrope ">
      <div className="bg-[#FFFFFF] border border-[#D9D9D9] h-[500px] min-h-[100%] flex rounded-[15px] ">
        { !state?.hideRecentRequestSection &&
        <div className="w-[23%]">
  <RecentRequestSection
          isLoading={recentRequestsLoading}
          previousRequestLoading={previousRequestLoading}
          filters={filters}
          selectedRequest={selectedRequest}
          requests={requests}
          hasMore={hasMore}
          fetchPreviousRequests={fetchPreviousRequests}
          fetchMoreRequests={fetchMoreRequests}
          handleRequestClick={(request) => {
            if(request?.id===selectedRequest?.id){
              return ;
            }
            setselectedRequest(request);
            setSelectedStatus(request?.status)
          }}
        />
        </div>
       }
        <div className={`${state?.hideRecentRequestSection?'w-[100%]':'w-[80%]'}  flex flex-col`}>
          <RequestDetailsHeader
            setPopupState={setPopupState}
            request={selectedRequest}
            sprayingRequest={sprayingRequest}
            requestInvoiceRef={requestInvoiceRef}
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
            onRequestUpdate={async (buttonType, updatedRequest) => {
              try {
                setIsLoading(true);
                const updatedRequests = requests.map((req) =>
                  req.id === updatedRequest.id
                    ? { ...req, status: updatedRequest?.status }
                    : req
                );
                setRequests(updatedRequests);
                setSelectedStatus(updatedRequest?.status);
                await getRequestDetails();
                if (buttonType === "Accepted") {
                  Popup.alert(
                    "Request Accepted!",
                    `Your request no. ${sprayingRequest?.req_number} has been accepted ! `,
                    "SUCCESS"
                  );
                } else if (buttonType === "Cancel") {
                  Popup.alert(
                    "Request Cancelled",
                    `Your request no. ${sprayingRequest?.req_number} has been cancelled !`,
                    "SUCCESS"
                  );
                }else if(buttonType==="Paid"){
                  Popup.alert(
                    "Request Paid",
                    `Your request no. ${sprayingRequest?.req_number} has been paid !`,
                    "SUCCESS"
                  );
                }
              } catch (err) {
                console.log("error", err);
                Popup.alert("ERROR", err, "ERROR");
              } finally {
                setIsLoading(false);
                Loading.set(false);
              }
            }}
          />
          <div className="w-full  max-h-full overflow-y-scroll h-full  flex">
            <RequestDetailsSection
              popupState={popupState}
              ref={requestInvoiceRef}
              sprayingRequest={sprayingRequest}
              isLoading={isLoading}
              setSprayingRequest={setSprayingRequest}
              setPopupState={setPopupState}
              request={selectedRequest}
              requestInvoiceRef={requestInvoiceRef}
              selectedStatus={selectedStatus} 
              setSelectedStatus={setSelectedStatus}
              onResetStatus={() => setSelectedStatus(selectedRequest?.status)}
              onRequestUpdate={async (updatedRequest, updateType) => {
                try {
                  setIsLoading(true);
                  const updatedRequests = requests.map((req) =>
                    req.id === updatedRequest.id
                      ? { ...req, status: updatedRequest?.status,
                         service_completed_area: updatedRequest?.service_completed_area,
            field_area: updatedRequest?.field_area,
            price_by: updatedRequest?.price_by,
            total_amount: updatedRequest?.total_amount,
                       }
                      : req
                  );
                  setRequests(updatedRequests);
                  setSelectedStatus(updatedRequest?.status)
                  await getRequestDetails();
                  setPopupState((prevState) => ({
                    ...prevState,
                    reschedule: false,
                  }));
                  if (updateType === STATUS.RESCHEDULED) {
                    Popup.alert(
                      "Request Reschedule!",
                      `Your request no. ${sprayingRequest?.req_number} has been Reschedule ! `,
                      "SUCCESS"
                    );
                  } else if (updateType === STATUS.CANCELLED) {
                    Popup.alert(
                      "Request Cancelled!",
                      `Your request no. ${sprayingRequest?.req_number} has been cancelled ! `,
                      "SUCCESS"
                    );
                  }else if(updateType===STATUS.HOLD){
                    Popup.alert(
                      "Request Hold!",
                      `Your request no. ${sprayingRequest?.req_number} has been hold! `,
                      "SUCCESS"
                    );
                  }else if(updateType===STATUS.COMPLETED){
                    Popup.alert(
                      "Request Completed!",
                      `Your request no. ${sprayingRequest?.req_number} has been completed! `,
                      "SUCCESS"
                    );
                  }
                  setIsLoading(false);
                } catch (err) {
                  setIsLoading(false);
                  console.log("error", err);
                  Popup.alert("ERROR", err, "ERROR");
                }
              }}
            />
            <div className="w-[25%] ">
              <VerticalStepper 
              steps={steps} 
              requestId={selectedRequest?.id} 
              comments={comments}  
              isLoading={isLoading}
              isCommentEditable={!user?.is_pdrl_admin}
              onCommentAdd={(comment)=>{
               setComments((prevComments)=>([...prevComments,comment]))
               Popup.alert("SUCCESS","comment added successfully !","SUCCESS")
              }}
              onCommentDelete={(id)=>{
                setComments((prevComments)=>(prevComments.filter((comment)=>comment.id!==id)))
                Popup.alert("SUCCESS","comment deleted successfully !","SUCCESS")
              }}
               />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
